import React, { useState, useEffect } from "react";

import { Button, InputAdornment, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, IconButton, CircularProgress, FormControl, Autocomplete, Switch, Stack, TextField, InputLabel, Select, MenuItem, FormHelperText, SelectChangeEvent, Box, Modal, Container} from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MapIcon from '@mui/icons-material/Map';
import LinkIcon from '@mui/icons-material/Link';
import DollarIcon from '@mui/icons-material/AttachMoney';
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import UploadIcon from '@mui/icons-material/CloudUpload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import dashboardServices from "../../../services/hoa-dashboard-api-service";

import config from '../../../hoa-config';

import '../../hoa-styles.scss';
import '../../municipalities/hoa-municipality-styles.scss';
import { Search } from "@mui/icons-material";
import SuccessMessage from "../../success-message/hoa-success-message";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import { isEmailValid,isPhoneValid, isValidHttpUrl } from "../../../utility/input-field-validation";
import PDFsContainerComponent from "../../../components/pdf-container-component/hoa-pool-access-form-pdf-container";
import SourceIdVerificationModal from "./common/SourceIdVerificationModal";
import { LoadingButton } from "@mui/lab";
import HoaEventForm from "./Hoa-event-form";
import useFieldDisabled from '../../../hooks/useFieldDisabled';
import HoaOnboardingForm from "../../../components/hoa-onboarding/hoa-onboarding-form";

interface HoaBasicFormProps {
    setCurrentHoa : any;
    checkError: boolean;
    height: number;
    selectedMunicipality: any;
    view: any;
    selectedValues : any;
    error: any;
    setError: any;
    emailValid: boolean;
    setEmailValid: any;
    phoneValid : boolean;
    setPhoneValid: any;
    state: any;
    setState: any;
    masterHoas: any;
    setMasterHoas: any;
    currentMasterHoa: any;
    setCurrentMasterHoa: any;
    updateHoaData: any;
    updateSelectedValues: any;
    hoaEvents: any;
    setHoaEvents: any;
    hoa: any;
    previousHoa: any;
    onboardingDataState: any;
    previousOnboardingDataState: any;
    setOnboardingDataState: any;
    onboardingDocuments: any;
    setOnboardingDocuments: any;
    populateOnboardingDocuments: any;
}

const communityOptions = [
'Snow Removal',
"Animal Services",
'Gardening',
'Trash',
"Recycling",
'Telephone',
'Internet',
'Satellite Television/ Cable',
'Landscaping'
]


export default function HoaBasicForm(props : HoaBasicFormProps) {

    const errorList : any = ['name', 'market', 'city', 'zip', 'coordinates', 'address', 'fees', 'paymentFrequency'];

    const {setCurrentHoa, checkError, view, selectedValues, error, setError, emailValid, phoneValid, setEmailValid, setPhoneValid, state, setState, masterHoas, setMasterHoas, currentMasterHoa, setCurrentMasterHoa, updateHoaData, updateSelectedValues, hoaEvents, setHoaEvents, height, hoa, previousHoa, onboardingDataState,previousOnboardingDataState, setOnboardingDataState, onboardingDocuments,setOnboardingDocuments, populateOnboardingDocuments } = props;
    const [availableCommunityServices, updateAvailableCommunityServices] = useState(communityOptions);
    const [openMasterHoa, setOpenMasterHoa] = useState(false);

    const [loadingMasterHoas, setLoadingMasterHoas] = useState(false);
    const [selectedOrganization, setSelectedOrganization] = useState(null);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [toBeDelete,setToBeDelete]=useState({})

    const { isHoaFieldDisabled } = useFieldDisabled();

	const addNewSourceDocument = () => {
		const newSource = {
			isVerified: false,
			sourceId: '',
			sourceIdType: ''
		}
        let tempState : any = {...state};
        tempState.gateAccessFormFiles = [newSource, ...tempState.gateAccessFormFiles]

        setState(tempState);
        setCurrentHoa(tempState);
	}

    const deleteSourceDocument = (index: number) => {
        const tempState = [...state.gateAccessFormFiles];
        tempState.splice(index, 1);
        let updatedState = {...state};
        updatedState.gateAccessFormFiles = tempState;
        setState(updatedState);
        setCurrentHoa(updatedState);
    }

	const handleSourceFile = (event: any, index: number) => {
		const {name, value} = event.target;
		const tempState = [...state.gateAccessFormFiles];
		tempState[index][name] = value;
		if (name === 'files' && value.length > 0) {
			tempState[index]['isVerified'] = true;
        } else if (name === 'files' && value.length == 0) {
			tempState[index]['isVerified'] = false;
        }
        let updatedState = {...state};
        updatedState.gateAccessFormFiles = tempState;
        setState(updatedState);
        setCurrentHoa(updatedState);
	}

    const toggleAttachDocumentModal = () => {
        setIsOpen(!isOpen);
        const isNew = Array.isArray(state.gateAccessFormFiles) && 
            state.gateAccessFormFiles.some((item: any) => item.hasOwnProperty('isVerified'));
        if(!state.gateAccessFormFiles || state.gateAccessFormFiles.length == 0 || !isNew) {
            addNewSourceDocument();
        }
    }

    const onUploadClick = () => {
        if(state.gateAccessFormFiles.length > 0) {
            setIsOpen(!isOpen);
        }
    }
    const newGateAccessFiles = Array.isArray(state.gateAccessFormFiles) &&
        state.gateAccessFormFiles.filter((item: any) => item.hasOwnProperty('isVerified'));
    const isAllVerified = newGateAccessFiles && 
        newGateAccessFiles.every((item: any) => item.isVerified);


    const onSelectOrgId = (event: SelectChangeEvent) => {
        if(event) {
            const orgId = event.target.value as any;
            const orgName = config.hoaOrganizations.find((org: any) => org.id === orgId)?.name;
            setSelectedOrganization(orgId);
            const matchingItems = state.hoaClientInfo.filter((item: any) => {
                if (item.clientId === orgId) {
                    return true;
                }
                return false;
            });
            if(matchingItems.length > 0){
                setSuccess(true);
                setMessage('Client already exist for this HOA.')
                return;
            }
            let tempState : any = JSON.parse(JSON.stringify(state));;
            const clientInfo = {
                clientName: orgName,
                clientId: orgId,
                fieldName: config.hoaClientInfoFieldName[orgName] || '',
                value: ''
            }
            tempState.hoaClientInfo.push(clientInfo);
            setState(tempState);
            setCurrentHoa(tempState);
        }
    }

    const handleVendorId = (value: any, index: number) => {
        let tempState : any = {...state};
        tempState.hoaClientInfo[index] = {
            ...tempState.hoaClientInfo[index],
            value: value
        }
        setState(tempState);
        setCurrentHoa(tempState);
    }

    useEffect(()=>{
        let tempState = {...state};
            if(props.selectedMunicipality && props.selectedMunicipality.market){
                if(tempState.municipality !== props.selectedMunicipality){
                    tempState.municipality = props.selectedMunicipality;
                }
                if(tempState.market !== props.selectedMunicipality.market){
                    tempState.market = props.selectedMunicipality.market;
                }
                if(tempState.city !== props.selectedMunicipality.city){
                    tempState.city = props.selectedMunicipality.city;
                }
            }
            
            setState(tempState);
            setCurrentHoa(tempState);
    }, [props.selectedMunicipality]);

    useEffect(() => {
        if (props.selectedValues?.masterHoa) {
            let tempState = {...state};
            tempState.masterHoa = props.selectedValues.masterHoa;
            tempState.masterHoaId = props.selectedValues.masterHoa.objectId;
            setCurrentMasterHoa(props.selectedValues.masterHoa);
            setState(tempState);
            setCurrentHoa(tempState);

            setMasterHoas([props.selectedValues.masterHoa]);
        }
        if (selectedValues.communityServices) {
            const newOptions = communityOptions.filter((option: string)=>{
                return !selectedValues.communityServices.includes(option);
            })
            updateAvailableCommunityServices(newOptions);
        }
    }, [props.selectedValues]);

    const isRequiredFieldEmpty = (tmpState: any) => {
        for(let key of errorList){
            if(!tmpState[key]){
                return true;
            }
        }
        return false;
    }

    const handleChange = (value: any, key: string) => {
        if(key === 'email' || key === 'loginEmail'){
            setEmailValid(isEmailValid(value as string));
        } else if(key === 'phone'){
            setPhoneValid(isPhoneValid(value as string));
        }
        let tempState : any = {...state};
        tempState[key] = value;
        setState(tempState);
        setCurrentHoa(tempState);
        if(isRequiredFieldEmpty(tempState)){
            setError(true);
        } else {
            if(tempState['propertyManagementCompanyAvailable'] && (!tempState.propertyManager?.propertyManagerName || !tempState.propertyManager?.propertyManagerCompanyAddress)) {
                setError(true);
                return;
            }
            setError(false);
        }
    }

    const Wheel =(e: any) => {
        e.target.blur();
    }

    const onLoadMasterHoas = async (event: any) => {
        if (event.key === "Enter") {
            setLoadingMasterHoas(true);

            const masterHoa = await dashboardServices.getHoasByName(event.target.value);
            if(Array.isArray(masterHoa?.data)) {
                let currentHoaIndex = -1;
                masterHoa.data.map((item:any, index: number) => {
                    if (item.objectId === props?.selectedValues?.objectId) {
                        currentHoaIndex = index;
                    }
                })

                if (currentHoaIndex > -1) {
                    masterHoa.data.splice(currentHoaIndex, 1);
                }

                setMasterHoas(masterHoa.data);
                setLoadingMasterHoas(false);
            }
        }
    }

    const onSelectMasterHoa = (value: any) => {
        let tempState : any = {...state};
        tempState.masterHoa = value;
        tempState.masterHoaId = value?.objectId;

        setCurrentMasterHoa(value);
        setState(tempState);
        setCurrentHoa(tempState);
    }

    const onOrganizationDelete = (id: number) => {
        let tempState : any = {...state};
        tempState.hoaClientInfo = tempState.hoaClientInfo.filter((info: any, idx: number) => info.clientId != id);
        setState(tempState);
        setCurrentHoa(tempState);
    }

    const deleteClick = (document: string, file: any) => {
		setToBeDelete(file);
		setOpen(!open);
    }
    const handleClose = () => {
        setOpen(!open);
    }

    const handleCommunityServiceChange = (value: any, key: string) => {
        let tempState : any = JSON.parse(JSON.stringify(state));
        if(key === 'communityServices' && value){
            tempState.communityServices.push(value);
            setState(tempState);
            setCurrentHoa(tempState);

            const newOptions = communityOptions.filter((option: string)=>{
                return !tempState.communityServices.includes(option);
            })
            updateAvailableCommunityServices(newOptions);
            return;
        }
    }

    return (
        <div>
         {
             view === 'update' &&
             <HoaOnboardingForm onboardingDataState={onboardingDataState} previousOnboardingDataState={previousOnboardingDataState} setOnboardingDataState={setOnboardingDataState} onboardingDocuments={onboardingDocuments} setOnboardingDocuments={setOnboardingDocuments} populateOnboardingDocuments={populateOnboardingDocuments}/>
         }
        <div style={{ width: "100%", height: props.height, overflowY:'scroll', borderRadius: "4px", fontSize: '20px', marginBottom: '24px' }} className = "add-municipality-form-container">
            <div className ="left-form-container">
                <div className="sub-title-text">Basic Information</div>
                <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between" }}>
                    <TextField style={{ width: "100%" }} variant="standard" label="HOA Name" required error = {checkError && !state.name} value={state.name}
                        onChange={(e)=>{handleChange(e.target.value, "name")}} InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isHoaFieldDisabled('name')}
                        InputProps={{style:{ padding:"7px 0px"}}}/>
                </div>
                <div style={{  marginTop: "24px"}}>
                    <TextField style={{ width: "100%" }} variant="standard" label="HOA Address" error={checkError && !state.address} value={state.address} required
                        onChange={(e)=>{handleChange(e.target.value, "address")}} InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isHoaFieldDisabled('address')}
                        InputProps={{style:{ padding:"7px 0px"}}}/>
                </div>
                <div style={{  marginTop: "24px"}}>
                    <TextField style={{ width: "45%" }} variant="standard" label="Zip" error={checkError && !state.zip} value={state.zip} required
                        onChange={(e)=>{handleChange(e.target.value, "zip")}} InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isHoaFieldDisabled('zip')}
                        InputProps={{style:{ padding:"7px 0px"}}}/>
                </div>
                <div style={{   display: "flex", marginTop: "24px", justifyContent: "space-between", alignItems:"baseline"}}>
                    <TextField style={{ width: "45%" }} variant="standard" label="Coordinates" error={checkError && !state.coordinates} value={state.coordinates} required
                        onChange={(e)=>{handleChange(e.target.value, "coordinates")}} InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isHoaFieldDisabled('coordinates')}
                        InputProps={{style:{ padding:"7px 0px"}}}/>
                    <Button  startIcon={<MapIcon color="primary"/>} variant="outlined"
                        onClick={()=>{
                            if(state.address){
                                window.open(`https://www.google.com/maps/search/${state.address}`, '_blank');
                            }
                        }}>
                        View In Map
                    </Button>
                </div>
                <div style={{ display: "flex", marginTop: "34px", width: "45%", alignItems:"baseline" }}>
                    <Autocomplete
                        id="asynchronous-demo"
                        sx={{ width: 300 }}
                        open={openMasterHoa}
                        onOpen={() => {
                            setOpenMasterHoa(true);
                        }}
                        onClose={() => {
                            setOpenMasterHoa(false);
                        }}
                        onKeyDown={onLoadMasterHoas}
                        onChange={(option:any, value:any) => onSelectMasterHoa(value)}
                        isOptionEqualToValue={(option, value) => option.objectId === value.objectId}
                        getOptionLabel={(option) => option.name}
                        value={currentMasterHoa}
                        options={masterHoas}
                        loading={loadingMasterHoas}
                        renderInput={(params: any) => (
                            <TextField
                                {...params}
                                label="Master Hoa"
                                disabled={isHoaFieldDisabled('masterHoaId')}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {loadingMasterHoas ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </div>
                <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between" }}>
                    <TextField style={{ width: "45%", }} variant="standard" value={state.phone} error={checkError && !phoneValid} helperText={checkError && !phoneValid ? 'Invalid number format' : ''}
                        onChange={(e)=>{handleChange(e.target.value, "phone")}} label="Phone Number" InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isHoaFieldDisabled('phone')}
                        InputProps={{
                            style:{ padding:"7px 0px"},
                            endAdornment :(
                                <InputAdornment position="end">
                                    <LocalPhoneIcon />
                                </InputAdornment>
                    )}}/>
                    <TextField style={{ width: "45%", }} variant="standard" value={state.email} error={checkError && !emailValid} helperText={checkError && !emailValid ? 'Invalid email format' : ''}
                        onChange={(e)=>{handleChange(e.target.value, "email")}} label="Email Address" InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isHoaFieldDisabled('email')}
                        InputProps={{
                            style:{ padding:"7px 0px"},
                            endAdornment :(
                                <InputAdornment position="end">
                                    <MailOutlineIcon />
                                </InputAdornment>
                    )}}/>
                </div>
                <div style={{ display: "flex", marginTop: "24px", justifyContent: "space-between" }}>
                <TextField style={{ width: "45%"}} value={state.fees} variant="standard" type = 'text' onWheel={e => Wheel(e)} required error = {checkError && !state.fees}
                    onChange={(e)=>{handleChange(e.target.value, "fees")}} label="HOA Fees" InputLabelProps={{style:{fontSize:"14px"}}}
                    disabled={isHoaFieldDisabled('fees')}
                    InputProps={{
                        style:{ padding:"7px 0px"},
                        endAdornment :(
                        <InputAdornment position="end">
                            <DollarIcon />
                        </InputAdornment>
                )}}/>
                <Autocomplete
                    ListboxProps={{ style: { maxHeight: "200px"} }}
                    style={{ width: "45%", height:"62px", boxSizing:"border-box"}}
                    disablePortal
                    value={state.paymentFrequency ? state.paymentFrequency : ''}
                    options={config.frequencyOptions}
                    onChange={(e, v) => {
                        handleChange(v, "paymentFrequency")
                    }}
                    disabled={isHoaFieldDisabled('paymentFrequency')}
                    renderInput={(params: any) => 
                        <TextField 
                            variant="standard"
                            style={{height:"100%"}} 
                            {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} 
                            label="Payment Frequency"
                            disabled={isHoaFieldDisabled('paymentFrequency')}
                        />}
                />
                </div>
                <div style={{  marginTop: "24px"}}>
                <TextField style={{ width: "45%"}} value={state.hoaFeesPaymentDeadline} variant="standard" type = 'text'
                    onChange={(e)=>{handleChange(e.target.value, "hoaFeesPaymentDeadline")}} label='HOA Payment Fees Deadline'InputLabelProps={{style:{fontSize:"14px"}}}
                    disabled={isHoaFieldDisabled('hoaFeesPaymentDeadline')}
                    InputProps={{style:{ padding:"7px 0px"}}}/>
                </div>
                <div style={{  marginTop: "24px"}}>
                    <TextField style={{ width: "100%" }} multiline variant="standard" label="HOA Payment Information" value={state.hoaPaymentInformation}
                        onChange={(e)=>{handleChange(e.target.value, "hoaPaymentInformation")}} InputLabelProps={{style:{fontSize:"14px"}}}
                        disabled={isHoaFieldDisabled('hoaPaymentInformation')}
                        InputProps={{style:{ padding:"7px 0px"}}}/>
                </div>
                <div style={{  marginTop: "24px"}}>
                    <div style={{margin:"12px 0px", fontSize: '14px', color: '#3E3E3E'}}>Board Meeting Schedule</div>
                    <TextField style={{ width: "75%", marginBottom:"24px"}} variant="outlined" value={state.boardMeetingSchedule}
                        onChange={(e) => { handleChange(e.target.value, "boardMeetingSchedule") }} label="Write here..." multiline
                        InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} InputProps={{ style: { minHeight:"106px" } }}
                        disabled={isHoaFieldDisabled('boardMeetingSchedule')}
                    />
                </div>
                <PropertyManagementComponent
                    setState={setState}
                    state={state}
                    checkError={checkError}
                    isPhoneValid={isPhoneValid}
                    setCurrentHoa={setCurrentHoa}
                    isRequiredFieldEmpty={isRequiredFieldEmpty}
                    setError={setError}
                    isEmailValid={isEmailValid}
                />
                <div className="sub-title-text" style={{paddingBottom: '14px'}}>Client Information</div>
                
                <div style={{ width: '100%' }} className="client-vendorid-add-container">
                    <FormControl style={{marginTop: '16px'}}>
                        <InputLabel id='organization-select-label'>Organization</InputLabel>
                        <Select
                            labelId='organization-select-label'
                            id='organization-select'
                            label='Organization'
                            value={selectedOrganization || ''}
                            onChange={onSelectOrgId}
                            variant='standard'
                            style={{ width: "280px" }}
                            disabled={isHoaFieldDisabled('hoaClientInfo')}
                        >
                            {config.hoaOrganizations.map((org: any) => {
                                return (
                                    <MenuItem key={org.id} value={org.id}>
                                        {org.name}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                    
                    {
                        state.hoaClientInfo && state.hoaClientInfo.map((item: any, index: number) => (
                            <div style={{display: 'flex',flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '400px', marginTop: '12px', border: '1px solid #E8E8E8', padding: '12px', backgroundColor: '#FFF'}} key={index}>
                                <span className="text-5B5B5B-14px" style={{width: '150px'}}>{item.clientName}</span>
                                <TextField style={{ width: "50%" }} variant="standard" label={config.hoaClientInfoFieldName[item.clientName]} value={item.value}
                                    onChange={(e)=>{handleVendorId(e.target.value, index)}} InputLabelProps={{style:{fontSize:"14px"}}}
                                    InputProps={{style:{ padding:"7px 0px"}}}
                                    disabled={isHoaFieldDisabled('hoaClientInfo')}
                                />
                                <IconButton disabled={isHoaFieldDisabled('hoaClientInfo')}>
                                    <DeleteOutline style={{cursor: "pointer"}} onClick={() => onOrganizationDelete(item.clientId)}/>
                                </IconButton>
                                {/* {
                                    newOrganization && newOrganization.find((info: any) => info.clientId === item.clientId) && (
                                        <DeleteOutline style={{cursor: "pointer"}} onClick={() => onOrganizationDelete(item.clientId)}/>
                                    )
                                } */}
                            </div>
                        ))
                    }
                </div>
            </div>
            {/*RIGHT*/}
            <div className ="right-form-container">
                <div className="sub-title-text" style={{marginBottom:"24px"}}>Additional Information</div>
                <div style={{
                    backgroundColor: state.isGateAccessRequired ? "#EFF4FC" : "", display: "flex", borderTop: "1px solid #E8E8E8",
                    borderBottom: "1px solid #E8E8E8", justifyContent:"space-between", alignItems:'center', padding: "15px 5px"
                }}>
                    <div style={{display:"flex", flexDirection:"column"}}>
                        <div style={{fontSize:"14px", lineHeight:"16px", margin:"5px 0px"}}>Gate Access Required</div>
                        <div className="helperText">Enable this if there is information regarding gate & guests.</div>
                    </div>
                    <Switch checked={state.isGateAccessRequired} value={state.isGateAccessRequired}
                        onChange={(e)=>{
                            if(!e.target.checked){
                                let tempState : any = {
                                    ...state,
                                    isGateAccessRequired: false,
                                    residentGateAccessRequirement: '',
                                    guestAccessPermission: '',
                                };
                                setState(tempState);
                                setCurrentHoa(tempState);
                            } else {
                                handleChange(e.target.checked, 'isGateAccessRequired');
                            }
                        }}
                        disabled={isHoaFieldDisabled('isGateAccessRequired') || isHoaFieldDisabled('residentGateAccessRequirement') || isHoaFieldDisabled('guestAccessPermission')}
                    />
                </div>

                {
                    state.isGateAccessRequired ?
                    <div style={{background:"#FAFAFA", padding:"24px 0px 0px 5px"}}>
                        <div style={{fontSize:"14px", marginBottom:"10px", lineHeight:"16px"}}>Resident Gate Access Requirement</div>
                        <TextField style={{ width: "75%", marginBottom:"24px"}} variant="outlined" value={state.residentGateAccessRequirement}
                            onChange={(e) => { handleChange(e.target.value, "residentGateAccessRequirement") }} label="Write here..." multiline
                            InputLabelProps={{ style: { fontSize: "14px", margin: "5px" } }} InputProps={{ style: { minHeight:"106px" } }}
                            disabled={isHoaFieldDisabled('residentGateAccessRequirement')}
                        />
                        <FormControl style={{marginBottom:"24px",fontSize:"14px"}}>
                            <FormLabel style={{fontSize:"14px", marginBottom:"10px", lineHeight:"16px"}}>Guest Access Permission</FormLabel>
                            <RadioGroup
                                row value={state.guestAccessPermission}
                                onChange={(e)=>{handleChange(e.target.value, "guestAccessPermission")}}
                            >
                                <FormControlLabel style={{fontSize:"14px", lineHeight:"16px"}} value="Yes" control={<Radio color="primary"/>} label="Yes"
                                    disabled={isHoaFieldDisabled('guestAccessPermission')}
                                />
                                <FormControlLabel style={{fontSize:"14px", lineHeight:"16px"}} value="No" control={<Radio color="primary"/>} label="No" 
                                    disabled={isHoaFieldDisabled('guestAccessPermission')}
                                />
                            </RadioGroup>
                        </FormControl>
                        <Box mt={"20px"} mb={"20px"}>
                            <div className="text-14px-5B5B5B">Gate Access Form</div>
                            <Stack flexDirection={"column"}>
                                <Button 
                                    sx={{width:"180px",marginTop: '20px'}}  startIcon={<UploadIcon color="primary"/>} variant="outlined" 
                                    onClick={toggleAttachDocumentModal}
                                    disabled={isHoaFieldDisabled('gateAccessFormFiles')}
                                >
                                    Attach Document
                                </Button>
                            </Stack>
                            {
                                    state.gateAccessFormFiles?.length > 0 && 
                                    state.gateAccessFormFiles.some((item: any) => item.files) ?
                                    <>
                                    <p className="helperText" style={{fontWeight:"bold"}}>Selected File :</p>
                                    {
                                        Array.from(state.gateAccessFormFiles).map((item: any, index: number)=> (
                                            item?.files && item.files.map((file: any, indx: number) => (
                                                <div style={{ cursor: "pointer" }} className="ov-pdf-container" >
                                                    <Stack direction={"row"} alignItems={"center"}>
                                                        <PictureAsPdfIcon style={{ width: "20px", height: "20px" }} />
                                                        <span style={{ marginLeft: "14px" }} className="text-3E3E3E-14px normal">
                                                            {file}
                                                        </span>
                                                    </Stack>
                                                </div>
                                            ))
                                        ))
                                    }
                                    </>
                                    : ''
                                }
                                {
                                    state.gateAccessFormFiles?.length > 0 && 
                                    state.gateAccessFormFiles.some((item: any) => item.url) ?
                                    <>
                                    <p className="helperText" style={{fontWeight:"bold"}}>Uploaded File :</p>
                                    {
                                        Array.from(state.gateAccessFormFiles).map((item : any, index: number)=>(
                                            item?.url && (
                                            <PDFsContainerComponent 
                                                document={`gateAccessFormFiles`} 
                                                deleteClick={deleteClick} 
                                                view={view} 
                                                key={index} 
                                                file={item} 
                                            />
                                            )))
                                    }
                                    </>
                                    : ''
                                }
                        </Box>

                    </div>
                    : ''
                }

                <div style={{
                    backgroundColor: state.isPortalAccessRequired ? "#EFF4FC" : "", display: "flex", borderBottom: "1px solid #E8E8E8",
                    justifyContent:"space-between", alignItems:'center', padding: "15px 5px"
                }}>
                    <div style={{display:"flex", flexDirection:"column"}}>
                        <div style={{fontSize:"14px", lineHeight:"16px", margin:"5px 0px"}}>Portal Access</div>
                        <div className="helperText">Enable this if you have HOA/PMC portal available. </div>
                    </div>
                    <Switch checked={state.isPortalAccessRequired} value={state.isPortalAccessRequired}
                        onChange={(e)=>{
                            if(!e.target.checked){
                                let tempState : any = {
                                    ...state,
                                    isPortalAccessRequired: false,
                                    hoaPortalLink: '',
                                    pmcPortalLink: '',
                                    residentLoginAvailable: false,
                                };
                                setState(tempState);
                                setCurrentHoa(tempState);
                            } else {
                                handleChange(e.target.checked, 'isPortalAccessRequired');
                            }
                        }}
                        disabled={
                            isHoaFieldDisabled('isPortalAccessRequired') || 
                            isHoaFieldDisabled('hoaPortalLink') || 
                            isHoaFieldDisabled('pmcPortalLink') || 
                            isHoaFieldDisabled('residentLoginAvailable')}
                    />

                </div>

                {
                    state.isPortalAccessRequired ?
                    <div style={{background:"#FAFAFA", padding:"24px 0px 0px 5px"}}>
                        <TextField style={{ width: "90%" }} value={state.hoaPortalLink}  variant="standard"
                        onChange={(e) => { handleChange(e.target.value, "hoaPortalLink") }} label="HOA Portal Link" InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                        helperText={state.hoaPortalLink?.trim().length > 0 && checkError && !isValidHttpUrl(state.hoaPortalLink as string) ? 'Invalid url format' : ''}
                        error={state.hoaPortalLink?.trim().length > 0 && checkError && !isValidHttpUrl(state.hoaPortalLink as string)}
                        disabled={isHoaFieldDisabled('hoaPortalLink')}
                        InputProps={{
                            style: { padding:"7px 0px" },
                            endAdornment: (
                                <InputAdornment position="end">
                                    <LinkIcon />
                                </InputAdornment>
                        )}}/>
                        <TextField 
                            style={{ width: "90%" }} 
                            value={state.pmcPortalLink}  
                            variant="standard"
                            onChange={(e) => { handleChange(e.target.value, "pmcPortalLink") }} 
                            label="PMC Portal Link" 
                            InputLabelProps={{ style: { fontSize: "14px", margin: "4px" } }}
                            helperText={state.pmcPortalLink?.trim().length > 0 && checkError && !isValidHttpUrl(state.pmcPortalLink as string) ? 'Invalid url format' : ''}
                            error={state.pmcPortalLink?.trim().length > 0 && checkError && !isValidHttpUrl(state.pmcPortalLink as string)}
                            disabled={isHoaFieldDisabled('pmcPortalLink')}
                            InputProps={{
                                style: { padding:"7px 0px" },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <LinkIcon />
                                    </InputAdornment>
                        )}}/>

                        <FormControlLabel style={{fontSize:"14px", marginTop:"10px"}}  label="Resident login is available"
                            control={
                                <Checkbox 
                                    color="primary" 
                                    checked={state.residentLoginAvailable} 
                                    value={state.residentLoginAvailable} 
                                    onChange={(e)=>{handleChange(e.target.checked, "residentLoginAvailable")}} 
                                    disabled={isHoaFieldDisabled('residentLoginAvailable')}
                                />}
                            />
                    </div>
                    : ''
                }

                <div style={{
                    backgroundColor: state.isCommunityServiceEnabled ? "#EFF4FC" : "",
                    display: "flex",
                    borderBottom: "1px solid #E8E8E8",
                    justifyContent: "space-between",
                    alignItems: 'center',
                    padding: "15px 5px"
                }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ fontSize: "14px", lineHeight: "16px", margin: "5px 0px" }}>Community Services</div>
                        <div className="helperText">Enable this if community services are available.</div>
                    </div>
                    <Switch checked={state.isCommunityServiceEnabled} value={state.isCommunityServiceEnabled}
                        onChange={(e) => {
                            if(!e.target.checked){
                                let tempState : any = {
                                    ...state,
                                    isCommunityServiceEnabled: false,
                                    communityServices: [],
                                };
                                setState(tempState);
                                setCurrentHoa(tempState);
                            } else {
                                handleChange(e.target.checked, 'isCommunityServiceEnabled');
                            }
                        }} 
                        disabled={isHoaFieldDisabled('isCommunityServiceEnabled') || isHoaFieldDisabled('communityServices')}
                    />

                </div>

                {
                    state.isCommunityServiceEnabled &&
                    <div style={{ paddingBottom:'10px'}}>
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px" } }}
                            style={{ width: "100%", height: "70px", boxSizing: "border-box", marginTop: '10px' }}
                            disablePortal
                            options={availableCommunityServices}
                            disabled={isHoaFieldDisabled('communityServices')}
                            onChange={(e, v) => {
                                handleCommunityServiceChange(v, "communityServices")
                            }}
                            renderInput={(params: any) =>
                                <TextField
                                    style={{ height: "100px" }} {...{ ...params }}
                                    variant="standard"
                                    InputProps={{
                                        ...params.InputProps,
                                        style: {
                                            height: '62px',
                                        },
                                        startAdornment: (
                                            <>
                                                <InputAdornment position="start">
                                                    <Search style={{ color: '#787878' }} />
                                                </InputAdornment>

                                            </>
                                        )
                                    }}
                                    placeholder="Write name here to add"
                                    disabled={isHoaFieldDisabled('communityServices')}
                                />}
                        />
                        <Stack direction='row' flexWrap={'wrap'}>
                            {
                                state.communityServices.map((service:string, index:number) => {
                                    return (
                                        <div className="communuty-service-single-container">
                                            <span className="text-5B5B5B-14px">{service}</span>
                                            <IconButton
                                                onClick={() => {
                                                    const existingService = state.communityServices.filter((currentAmenity:string)=> {return currentAmenity !== service});
                                                    setState({
                                                        ...state,
                                                        communityServices:existingService
                                                    })
                                                    setCurrentHoa({
                                                        ...state,
                                                        communityServices:existingService
                                                    })
                                                    updateAvailableCommunityServices([...availableCommunityServices,service])
                                                }}
                                                style={{ marginLeft: "8px" }}
                                                disabled={isHoaFieldDisabled('communityServices')}
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                        </div>
                                    )
                                })
                            }
                        </Stack>

                    </div>
                }
                <HoaEventForm
                    hoa={hoa}
                    previousHoa={previousHoa}
                    setCurrentHoa={setCurrentHoa}
                    updateHoaData={updateHoaData}
                    updateSelectedValues={updateSelectedValues}
                    hoaEvents={hoaEvents}
                    setHoaEvents={setHoaEvents}
                    height={height}
                    view={view}
                    setState={setState}
                    state={state}
                />
            </div>
            <SuccessMessage success={success} setSuccess={setSuccess} message={message} />
            {
                isOpen &&
                <SourceIdVerificationModal 
                    open={isOpen}
                    setOpen={setIsOpen}
                    loading={loading}
                    setLoading={setLoading}
                    handleClose={toggleAttachDocumentModal}
                    addNewSourceDocument={addNewSourceDocument}
                    sourceFileInfo={state.gateAccessFormFiles.filter((item: any) => item.hasOwnProperty('isVerified'))}
                    handleSourceFile={handleSourceFile}
                    handleDeleteCard={deleteSourceDocument}
                    isAllVerified={isAllVerified}
                    onUploadClick={onUploadClick}
                />
            }
            <DeleteAttachmentComp
                open={open}
                state={state}
                setState={setState}
                handleClose={handleClose}
                toBeDelete={toBeDelete}
                setToBeDelete={setToBeDelete}
                setCurrentHoa={setCurrentHoa}
			/>
        </div>
        </div>
    )
}

export const PropertyManagementComponent = (props:any) => {
    const { setState, state, checkError, isPhoneValid, isRequiredFieldEmpty, setError,setCurrentHoa, isEmailValid } = props;
    const { isPropertyManagerDisabled, isPropertyManagerFieldDisabled } = useFieldDisabled();

    const handleChange = (value:any, key:string) => {
        const tmpState = JSON.parse(JSON.stringify(state));
        if(key === 'propertyManagementCompanyAvailable'){
            if(!value){
                tmpState.propertyManager = {};
            }
            tmpState[key] = value;
        } else {
            tmpState.propertyManager[key] = value;
        }
        setState(tmpState)
        setCurrentHoa(tmpState)

        if(!tmpState['propertyManagementCompanyAvailable']) {
            setError(false);
            return;
        }

        if(!tmpState.propertyManager || Object.keys(tmpState.propertyManager).length === 0  || !tmpState.propertyManager?.propertyManagerName || !tmpState.propertyManager?.propertyManagerCompanyAddress) {
            setError(true);
        }else {
            setError(false);
        }
    }

    return (
		<Stack>
			<FormControlLabel
				style={{ fontSize: "14px", marginTop: "34px" }}
				label="Property management company is available"
				control={
					<Checkbox
						color="primary"
						checked={state.propertyManagementCompanyAvailable}
						value={state.propertyManagementCompanyAvailable}
						onChange={(e) => {
							handleChange(e.target.checked, "propertyManagementCompanyAvailable");
						}}
                        disabled={isPropertyManagerDisabled()}
					/>
				}
			/>

            {
                state.propertyManagementCompanyAvailable &&
                <Stack direction={"column"} margin={"5px 0px"}>
                    <TextField
                        style={{ width: "318px" }}
                        variant="standard"
                        label="Property Manager"
                        required
                        error={checkError && !state.propertyManager?.propertyManagerName}
                        value={state.propertyManager?.propertyManagerName}
                        onChange={(e) => {
                            handleChange(e.target.value, "propertyManagerName");
                        }}
                        InputLabelProps={{ style: { fontSize: "14px" } }}
                        InputProps={{ style: { padding: "7px 0px" } }}
                        disabled={isPropertyManagerFieldDisabled('propertyManagerName')}
                    />
                    <TextField
                        style={{ width: "100%", margin: '8px 0px' }}
                        variant="standard"
                        label="Property Management Company Address"
                        required
                        error={checkError && !state.propertyManager?.propertyManagerCompanyAddress}
                        value={state.propertyManager?.propertyManagerCompanyAddress}
                        onChange={(e) => {
                            handleChange(e.target.value, "propertyManagerCompanyAddress");
                        }}
                        InputLabelProps={{ style: { fontSize: "14px" } }}
                        InputProps={{ style: { padding: "7px 0px" } }}
                        disabled={isPropertyManagerFieldDisabled('propertyManagerCompanyAddress')}
                    />
                    <Stack direction={'row'} justifyContent={'space-between'} margin={'10px 0px'}>
                        <TextField
                            style={{ width: "45%" }}
                            variant="standard"
                            error={checkError && state.propertyManager?.propertyManagerPhone && (!isPhoneValid(state.propertyManager?.propertyManagerPhone))}
                            value={state.propertyManager?.propertyManagerPhone}
                            helperText={checkError && (state.propertyManager?.propertyManagerPhone && !isPhoneValid(state.propertyManager?.propertyManagerPhone)) ? 'Invalid number format' : ''}
                            onChange={(e) => {
                                handleChange(e.target.value, "propertyManagerPhone");
                            }}
                            label="Property Manager Phone"
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            disabled={isPropertyManagerFieldDisabled('propertyManagerPhone')}
                            InputProps={{
                                style: { padding: "7px 0px" },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <LocalPhoneIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <TextField
                            style={{ width: "45%" }}
                            variant="standard"
                            error={checkError && (state.propertyManager?.propertyManagerEmail && !isEmailValid(state.propertyManager?.propertyManagerEmail))}
                            value={state.propertyManager?.propertyManagerEmail}
                            helperText={checkError && state.propertyManager?.propertyManagerEmail && !isEmailValid(state.propertyManager?.propertyManagerEmail) ? 'Invalid Email format' : ''}
                            onChange={(e) => {
                                handleChange(e.target.value, "propertyManagerEmail");
                            }}
                            label="Property Manager Email"
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            disabled={isPropertyManagerFieldDisabled('propertyManagerEmail')}
                            InputProps={{
                                style: { padding: "7px 0px" },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <MailOutlineIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Stack>
                </Stack>
            }

		</Stack>
	);
}

const DeleteAttachmentComp = ({
	open,
    state,
    setState,
	handleClose,
    toBeDelete,
    setToBeDelete,
    setCurrentHoa,
}: any) => {
	const [isLoading, setLoading] = useState(false);

	const handleDelete = () => {
        if(toBeDelete.fileName){
            setLoading(true);
            let arr = state.gateAccessFormFiles.filter((item: any) => {
                return item.fileName != toBeDelete.fileName
            })
            let tempState = {...state};
            tempState.gateAccessFormFiles = arr;
            setState(tempState);
            setCurrentHoa(tempState);
            setToBeDelete({});
            setLoading(false);
            handleClose();
        }
	};

	const onClose = () => {
		handleClose();
	};

	return (
		<Modal open={open} onClose={onClose}>
			<Container className="modal-container-style">
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted once you save information. It cannot be retrieved afterward</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
						{!isLoading ? (
							<>
								<Button onClick={() => onClose()} variant="outlined">
									No
								</Button>
								<Button onClick={handleDelete} variant="contained">
									Yes
								</Button>
							</>
						) : (
							<LoadingButton
								loading
								loadingIndicator="Deleting..."
								variant="outlined"
							>
								Deleting Data
							</LoadingButton>
						)}
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}